var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Liquidity-Pool",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LP-Landing",
    transform: "translate(-377.000000, -494.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(377.000000, 494.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#000000",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "stellar-xlm-logo-2",
    transform: "translate(5.000000, 6.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stellar-xlm-logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9915612,1.62149254 L10.3103797,2.48716418 L2.1921519,6.66626866 C2.16470041,6.45466258 2.15088788,6.24147681 2.15080169,6.0280597 C2.15306033,4.29542307 3.06274965,2.69348138 4.54185359,1.817473 C6.02095754,0.941464619 7.84839813,0.922324342 9.34514768,1.76716418 L10.3074262,1.27164179 L10.4509705,1.19761194 C8.65357863,-0.12087069 6.27634344,-0.309032143 4.29777203,0.710577773 C2.31920063,1.73018769 1.07369475,3.78524296 1.07392405,6.02985075 C1.07392405,6.18189055 1.07963432,6.33333333 1.09105485,6.4841791 C1.12376095,6.92097406 0.893608431,7.33486237 0.50742616,7.53373134 L0,7.79522388 L0,9.01492537 L1.49392405,8.24537313 L1.49392405,8.24537313 L1.97772152,7.9958209 L2.45443038,7.75044776 L2.45443038,7.75044776 L11.0127426,3.34328358 L11.9744304,2.84835821 L13.9621941,1.82447761 L13.9621941,0.605373134 L11.9915612,1.62149254 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9621941,3.04477612 L2.94059072,8.71641791 L1.97890295,9.21253731 L0,10.2316418 L0,11.4501493 L1.96531646,10.438209 L3.64649789,9.57253731 L11.7729958,5.38746269 C11.8004672,5.60046721 11.8142794,5.81504438 11.814346,6.02985075 C11.8132822,7.76456156 10.9025427,9.36873731 9.42124357,10.2450595 C7.9399444,11.1213816 6.11004454,11.1385414 4.61291139,10.2901493 L4.55383966,10.321791 L3.51063291,10.8591045 C5.30760222,12.17762 7.68441076,12.36623 9.66297239,11.3473192 C11.641534,10.3284083 12.8875503,8.27413216 12.88827,6.02985075 C12.88827,5.87641791 12.8823629,5.72298507 12.8711392,5.57134328 C12.8384874,5.13472091 13.0683393,4.72095441 13.4541772,4.52179104 L13.9621941,4.26029851 L13.9621941,3.04477612 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlm);
export default __webpack_public_path__ + "static/media/xlm.193df9575fa048fb02acffddd87b708e.svg";
export { ForwardRef as ReactComponent };